/* Wendle cart: change-options pop-up + header menu links. Requires bf.js */
(() => {
  'use strict';
  const BF = window.BF || {};
  const close = (m) => { if (m) { m.hidden = true; } };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-bf-cvm-open]');
    if (o) { e.preventDefault(); const m = document.getElementById(o.dataset.bfCvmOpen); if (m) { m.hidden = false; const c = m.querySelector('input:checked'); if (c) c.closest('label').scrollIntoView({ block: 'center' }); } return; }
    const x = e.target.closest('[data-bf-cvm-close]'); if (x) close(x.closest('[data-bf-cvm]'));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') document.querySelectorAll('[data-bf-cvm]:not([hidden])').forEach(close); });
  document.addEventListener('change', async (e) => {
    const r = e.target.closest('[data-bf-cvm-pick]'); if (!r) return;
    const m = r.closest('[data-bf-cvm]'); const id = parseInt(r.value, 10);
    if (String(id) === m.dataset.current) { close(m); return; }
    m.classList.add('is-busy');
    const line = document.querySelector(`.bf-line[data-key="${CSS.escape(m.dataset.key)}"]`); if (line) line.classList.add('is-busy');
    try {
      await BF.add([{ id, quantity: parseInt(m.dataset.qty, 10) || 1 }], false);
      await BF.change(m.dataset.key, 0);
    } catch (err) { if (BF.toast) BF.toast(err.message); m.classList.remove('is-busy'); if (line) line.classList.remove('is-busy'); }
  });
  /* Sticky add-to-cart label = main button label */
  const st = document.querySelector('[data-bf-sticky] button');
  const lab = document.querySelector('[data-bf-atc-label]');
  if (st && lab) { const t = Array.from(st.childNodes).find((n) => n.nodeType === 3 && n.textContent.trim()); if (t) t.textContent = lab.textContent.trim(); }
  /* Header: Shop / Men / Women / Kids open their full collection page on click (hover still shows the menu) */
  const root = (window.Wendle && window.Wendle.routes && window.Wendle.routes.root) || '/';
  document.querySelectorAll('.bf-nav__item.has-panel').forEach((li) => {
    const btn = li.querySelector('[data-bf-nav-btn]'); if (!btn) return;
    const all = li.querySelector('.bf-strip__all a');
    const href = all ? all.getAttribute('href') : (li.querySelector('.bf-mega') ? root + 'collections/all' : null);
    if (!href) return;
    btn.addEventListener('click', (e) => {
      if (!matchMedia('(hover: hover)').matches && !li.classList.contains('is-open')) return; // touch: first tap opens the menu
      e.preventDefault(); e.stopImmediatePropagation(); window.location.href = href;
    }, true);
  });
  document.querySelectorAll('#BfMenu details').forEach((d) => {
    const all = Array.from(d.querySelectorAll('.bf-mmenu__sub a')).find((a) => /view all/i.test(a.textContent));
    if (!all) return;
    const sum = d.querySelector('summary');
    const a = document.createElement('a'); a.href = all.getAttribute('href'); a.className = 'bf-mmenu__all'; a.textContent = 'Shop all ' + sum.textContent.trim();
    a.style.cssText = 'display:block;font-weight:700;padding:8px 0 4px';
    d.querySelector('.bf-mmenu__sub').prepend(a);
  });
})();